import { Print } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Divider, Grid, Typography } from '@mui/material'
import * as controllers from 'controllers'
import { useEffect, useState } from 'react'

export default function LabelPrintingCard() {
  const [isPrintingTestLabel, setIsPrintingTestLabel] = useState(false)

  useEffect(() => {
    controllers.initializeBluetoothLabelPrinterState().catch(error => {
      console.warn('Could not initialize Bluetooth label printer state:', error)
    })
  }, [])

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12}>
            <Typography fontWeight='bold' variant='h5'>
              Label Printing
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Button
              disabled={isPrintingTestLabel}
              endIcon={isPrintingTestLabel ? <CircularProgress color='inherit' size={20} /> : <Print />}
              fullWidth
              onClick={() => {
                setIsPrintingTestLabel(true)
                controllers.printBluetoothTestLabelFromUserGesture().finally(() => {
                  setIsPrintingTestLabel(false)
                })
              }}
              variant='outlined'
            >
              {isPrintingTestLabel ? 'PRINTING TEST LABEL...' : 'PRINT TEST LABEL'}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
